// export const API_URL = 'http://localhost:8080'; // LOCAL
export const API_URL = 'https://app.clickchauffeur.com:8443'; // PROD
export const WEBSITE = 'https://www.clickchauffeur.com';
export const ACCESS_TOKEN = 'accessToken';
export const EMAIL = 'email';
export const NAME = 'name';
export const PHONE = 'phone';
export const DAYS_BORDER_COLOR = '#262B40';
export const CHART_COLOR = '#2A6FDB'; // accent V2 (anciennement #424D7C) — utilisé seulement par les graphiques du tableau de bord
export const LANGUAGE = 'clickchauffeur-language';
export const MAPBOX = 'pk.eyJ1Ijoid2ViYXVkaXQiLCJhIjoiY2w0ZHd4dGg3MGNvcDNkam5lMGk4ZmR3ciJ9.25x8UpR7xO1NWgzdqbrGPg';
export const GOOGLE_CONNECTIONS = 'https://myaccount.google.com/connections';
